import React from "react";

const AgencyContext = React.createContext();

export default AgencyContext;
